import KendoCalendarMixin from './KendoCalendarMixin'

export default {
    name: 'kendo-calendar',
    mixins: [ KendoCalendarMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoCalendar/index.js